import React from 'react';

import {ListMessage} from 'app/components/general/ListMessage';
import {EditQuestion} from 'app/quizzes/components/QuizEditPage/EditableContent/EditQuestion';
import {gt} from 'app/utils/i18n';

import type {QuizContentWithDiffType} from 'app/quizzes/types';

type Props = {
  content: QuizContentWithDiffType['content'];
};

export const ViewContent = ({content}: Props) =>
  (content?.length ?? 0) > 0 ? (
    <ol className="steps">
      {content?.map((question, index) => (
        <li key={question.id}>
          <EditQuestion question={question} n={index + 1} />
        </li>
      ))}
    </ol>
  ) : (
    <ListMessage>{gt('This quiz has no content.')}</ListMessage>
  );
